// Action Types
export const START_IMPERSONATION = 'START_IMPERSONATION';
export const STOP_IMPERSONATION = 'STOP_IMPERSONATION';

// Action Creators
export const startImpersonation = (data) => async (dispatch) => {
  await dispatch({
    type: START_IMPERSONATION,
    data: data,
  });
};

export const stopImpersonation = () => async (dispatch) => {
  await dispatch({
    type: STOP_IMPERSONATION,
  });
};

const initState = {
  isImpersonating: false,
  originalAdminUser: null,
  originalAdminToken: null,
  impersonatedStudent: null,
  studentToken: null,
  returnSchoolId: null,
  returnStudentId: null,
  impersonatedRole: null,
  returnPath: null,
  returnCounselorId: null,
};

const ImpersonationReducer = (state = initState, action) => {
  switch (action.type) {
    case START_IMPERSONATION:
      return {
        ...state,
        isImpersonating: true,
        originalAdminUser: action.data.originalAdminUser,
        originalAdminToken: action.data.originalAdminToken,
        impersonatedStudent: action.data.impersonatedStudent,
        studentToken: action.data.studentToken,
        returnSchoolId: action.data.returnSchoolId,
        returnStudentId: action.data.returnStudentId,
        impersonatedRole: action.data.impersonatedRole || 'student',
        returnPath: action.data.returnPath || null,
        returnCounselorId: action.data.returnCounselorId || null,
      };
    case STOP_IMPERSONATION:
      return {
        ...initState,
      };
    default:
      return state;
  }
};

export default ImpersonationReducer;
